/**
* Created by lobin on 2020/7/14.
*/
<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">
    <div style="display: flex;justify-content: space-between">
      <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
        <a-form-model-item>
          <station-select type="input" v-model="search.station" />
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.code" placeholder="单号" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.phone" placeholder="电话" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search.subfix" placeholder="隐私号" allowClear></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-select v-model="search.channel" placeholder="来源渠道" allowClear style="width: 100px">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="mp">公众号</a-select-option>
            <a-select-option value="client">客户端</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            type="primary"
            html-type="submit"
            icon="search"
          >
            查询
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
		<a-divider />
		<a-table
			:loading="listloading"
			:columns="columns"
			:data-source="list"
			:pagination="pager"
			@change="change">
			<span slot="status" slot-scope="text">
				<a-tag color="red" v-if="text === 'NOT_CONFIRM'">未确认</a-tag>
        <a-tag color="green" v-if="text === 'CONFIRMED'">已确认</a-tag>
			</span>
      <span slot="channel" slot-scope="text">
				<a-tag color="green" v-if="text === 'mp'">公众号</a-tag>
        <a-tag color="#1677FF" v-if="text === 'client'">客户端</a-tag>
			</span>
			<span slot="action" slot-scope="text, record">
        <a-button @click="updateComfirmCustomer(record)" type="primary" size="small" :disabled="record.status === 'CONFIRMED'">确认</a-button>
			</span>
		</a-table>
	</a-card>
</template>

<script type="text/babel">
import {
  confirmUser,
  comfirmCustomer,
} from '@/api/user';
import barcode from 'vue-barcode';
export default {
  components: {
    barcode
  },
  data() {
    return {
      listloading: false,
      list: [],
      pager: {},
      search: {},
      searchRange: [],
      id: '',
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };
  },
  created() {
    this.getList();
  },
  computed: {
    columns() {
      return [
	      {
		      title: '#',
		      dataIndex: 'index',
		      customRender: (text, row, index) => index + 1,
		      key: 'index',
		      width: '50px',
	      },
        {
          title: '站点',
          dataIndex: 'station.name',
          key: 'stationName',
        },
        {
          title: '单号',
          dataIndex: 'code',
          key: 'code',
        },
        {
          title: '电话',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: '隐私号',
          dataIndex: 'subfix',
          key: 'subfix',
        },
        {
          title: '来源',
          dataIndex: 'channel',
          key: 'channel',
          scopedSlots: { customRender: 'channel' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
	        scopedSlots: { customRender: 'status' },
        },
        {
          title: '时间',
          dataIndex: 'ctime',
          key: 'ctime',
          width: '200px',
        },
	      {
		      title: '操作',
		      key: 'action',
		      fixed: 'right',
		      scopedSlots: { customRender: 'action' },
	      },
      ];
    },
    rules() {
      return {
        station: [
          { required: true, message: '请选择所属小区', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入客户电话', trigger: 'blur' },
        ],
        name: [
          { required: false, message: '请输入客户姓名', trigger: 'blur' },
        ],
        address: [
          { required: false, message: '请输入客户地址', trigger: 'blur' },
        ],
      };
    },
  },
  methods: {
    async getList() {
      this.listloading = true;
      const q = { ...this.search };
      // eslint-disable-next-line prefer-destructuring
      q.start = this.searchRange[0];
      // eslint-disable-next-line prefer-destructuring
      q.end = this.searchRange[1];
      try {
        const { data: { docs, pager } } = await confirmUser(q);
        this.list = docs;
        this.pager = {
	        ...pager,
	        showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        console.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.search.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
    async updateComfirmCustomer(row) {
      const res = await comfirmCustomer({
        id: row._id,
      });
      if(res.code === 0) {
        this.$message.success('操作成功');
      } else {
        this.$message.error(res.message);
      }
      this.getList();
    }
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.user-list {

	}
</style>
